var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4883 14.5447H36.2383V9.29468C36.2383 8.30012 35.8432 7.34629 35.1399 6.64303C34.4367 5.93977 33.4828 5.54468 32.4883 5.54468H8.48828C7.49372 5.54468 6.53989 5.93977 5.83663 6.64303C5.13337 7.34629 4.73828 8.30012 4.73828 9.29468V33.2947C4.73847 33.7193 4.85882 34.1352 5.08541 34.4943C5.31201 34.8535 5.6356 35.1411 6.01879 35.3241C6.40198 35.5071 6.82913 35.5779 7.25086 35.5283C7.67259 35.4787 8.07169 35.3109 8.40203 35.0441L13.7383 30.7316V34.7947C13.7383 35.7892 14.1334 36.7431 14.8366 37.4463C15.5399 38.1496 16.4937 38.5447 17.4883 38.5447H34.7702L41.5745 44.0441C41.9049 44.3109 42.304 44.4787 42.7257 44.5283C43.1474 44.5779 43.5746 44.5071 43.9578 44.3241C44.341 44.1411 44.6646 43.8535 44.8912 43.4943C45.1177 43.1352 45.2381 42.7193 45.2383 42.2947V18.2947C45.2383 17.3001 44.8432 16.3463 44.1399 15.643C43.4367 14.9398 42.4828 14.5447 41.4883 14.5447ZM9.23828 28.5828V10.0447H31.7383V25.0447H14.4095C13.8923 25.0432 13.3904 25.22 12.9883 25.5453L9.23828 28.5828ZM40.7383 37.5828L36.9883 34.5453C36.5882 34.2217 36.0892 34.045 35.5745 34.0447H18.2383V29.5447H32.4883C33.4828 29.5447 34.4367 29.1496 35.1399 28.4463C35.8432 27.7431 36.2383 26.7892 36.2383 25.7947V19.0447H40.7383V37.5828Z",
    fill: "url(#paint0_linear_1601_19223)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1601_19223",
    x1: 24.9883,
    y1: 5.54468,
    x2: 24.9883,
    y2: 44.5437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/Chats.88d8adce954c36522d068aa6d8349d62.svg";
export { ForwardRef as ReactComponent };